<template>
  <div class="mb-6">
    <section aria-labelledby="pipeline-reviews-title">
      <div>
        <div class="mt-6 flex justify-end items-center">
          <div>
            <TButton @click="showPipeReviewChangeReviewer = true" class="mr-2" color="white" label="Update Reviewer" />
            <router-link :to="`/team/${$route.params.id}/pipeline_reviews/new`">
              <TButton color="amber" label="New" />
            </router-link>
          </div>
        </div>
        <div class="mt-6">
          <ul v-if="pipelineReviews?.length > 0" role="list" class="divide-y divide-gray-200">
            <li v-for="pr in pipelineReviews" class="py-2">
              <router-link :to="pipelineReviewUrl(pr)" class="flex justify-between">
                <div class="flex items-center gap-2">
                  <PipelinePerformanceSmile :score="pr.score" />
                  <span>{{ formatDate(pr.date_of_meeting, 'MMMM dd, yyyy') }}</span>
                </div>
                <TButton color="white" label="View pipeline review" size="sm" />
              </router-link>
            </li>
          </ul>
          <div v-else class="text-center text-gray-500 text-sm">
            This agent hasn't had any pipeline reviews.

            <router-link :to="`/team/${$route.params.id}/pipeline_reviews/new`" class="block mx-auto mt-3">
              <TButton color="amber" label="Create pipeline review" size="sm" />
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <TeammatePipelineReviewsChangeReviewerVue
      v-if="showPipeReviewChangeReviewer"
      :contact="contact"
      @handleSubmit="
        showPipeReviewChangeReviewer = false;
        $emit('refreshContact');
      "
      @handleCancel="showPipeReviewChangeReviewer = false"
    />
  </div>
</template>

<script>
import Card from '../Card/index.vue';
import PipelinePerformanceSmile from '../PipelinePerformanceSmile/index.vue';
import TeammatePipelineReviewsChangeReviewerVue from './TeammatePipelineReviewsChangeReviewer.vue';
import DateUtility from '../../utilities/dates';

export default {
  props: ['contact'],
  components: {
    Card,
    PipelinePerformanceSmile,
    TeammatePipelineReviewsChangeReviewerVue,
  },
  data() {
    return {
      pipelineReviews: null,
      showPipeReviewChangeReviewer: false,
    };
  },
  async mounted() {
    await this.fetchPipelineReviews();
  },
  methods: {
    ...DateUtility,
    async fetchPipelineReviews() {
      const res = await fetch(`/api/contacts/${this.$route.params.id}/pipeline_reviews`);
      const data = await res.json();
      this.pipelineReviews = data;
    },
    pipelineReviewUrl(pr) {
      if (pr.contact_event) {
        return `/contact_events/${pr.contact_event.id}/pipeline_review`;
      } else {
        return `/team/${this.$route.params.id}/pipeline_reviews/${pr.id}`;
      }
    },
  },
};
</script>
